import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import VueRouter from "vue-router";
import vco from "v-click-outside";
import router from "./router/index";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import store from "@/state/store";
import App from "./App.vue";
import i18n from "./utils/i18n";
// import { Table,Tabs } from 'buefy';
import Toast from "vue-toastification";
import moment from 'vue-moment';
import momentTimezone from 'moment-timezone'
import Collapsible from 'vue-collapsible-component';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import ImageUploader from 'vue-image-upload-resize';
import Viewer from "v-viewer";
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';
import 'vue-material/dist/vue-material.min.css'
import VpMultiselect from "@/components/sharedComponents/Multiselect.vue"
import VpInput from "@/components/sharedComponents/Input.vue"
import VpSwitch from "@/components/sharedComponents/Switch.vue"
import { MdRipple, MdField, MdButton, MdSwitch } from 'vue-material/dist/components'
import GlobalButton from '@/components/sharedComponents/GlobalButton.vue';

// import the styles
import 'vue-collapsible-component/lib/vue-collapsible.css';
import "vue-toastification/dist/index.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "@/design/index.scss";
import "vue2-datepicker/index.css";
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.css';
import "viewerjs/dist/viewer.css";
import VueCountdown from '@chenfengyuan/vue-countdown';
import devExtremeMessages from '@/utils/locales/devextreme.js';
import { locale, loadMessages } from "devextreme/localization";


//Devextreme locale file
const currentLang = store.getters['i18N/getLanguage'];
loadMessages(devExtremeMessages);
locale(currentLang);

// socket.io
// import VueSocketio from 'vue-socket.io';

// Configure Vuetify with MDI as the default icon font
const vuetify = new Vuetify({
  options: {
    customProperties: true
  },
  icons: {
    iconfont: 'mdi', // Specify MDI as the default icon font
  },
  theme: {
    themes: {
      light: {
        primary: '#1976D2',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  },
});

// Vue.use(new VueSocketio({
//     // debug: true,
//     connection: process.env.VUE_APP_GRID_SYNC_URL,
//     vuex: {
//       store,
//       actionPrefix: "SOCKET_",
//       mutationPrefix: "SOCKET_"
//     }
//   })
// );

Vue.component(VueCountdown.name, VueCountdown);

Vue.use(MdRipple);
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdSwitch);
Vue.component('VpButton', GlobalButton);
Vue.component('VpMultiselect', VpMultiselect)
Vue.component('VpInput', VpInput)
Vue.component('VpSwitch', VpSwitch)

Vue.use(VueRouter);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Toast);
Vue.use(moment, {
  momentTimezone
});
Vue.use(Collapsible);
// buefy components
// Vue.use(Table);
// Vue.use(Tabs);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(VueSweetalert2);
Vue.use(ImageUploader);
Vue.use(Viewer);
Vue.use(Vuetify);
Vue.component('VueQrcode', VueQrcode);
new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
